// extracted by mini-css-extract-plugin
export var acitonButtons = "_fr-0";
export var additionalIcon = "_fr-f";
export var block = "_fr-1";
export var blockContent = "_fr-7";
export var blockDescription = "_fr-8";
export var blockIcon = "_fr-9";
export var blockTitle = "_fr-6";
export var border = "_fr-a";
export var center = "_fr-l";
export var edge = "_fr-b";
export var edgeLabel = "_fr-c";
export var edgePath = "_fr-d";
export var error = "_fr-e";
export var flowchart = "_fr-g";
export var flowchartContent = "_fr-h";
export var highlighted = "_fr-3";
export var hover = "_fr-4";
export var icon = "_fr-i";
export var left = "_fr-m";
export var navButton = "_fr-j";
export var navButtons = "_fr-k";
export var right = "_fr-n";
export var selected = "_fr-2";
export var small = "_fr-5";